import { ModuleDefinition, ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";
import { getNameFromModuleDefinition } from "src/stores/TemplateStore";

/**
 * creates ExtendedFTNode equivalent of provided ModuleDefintion
 * @param  {ModuleDefinition} moduleDefinition
 * @param {boolean} includeDescendants - Default TRUE. If true, all descendants will be converted to ExtendedFTNode objects while populating it's childNodes. If false, childNodes will not be populated
 * @returns ExtendedFTNode
 */
export const moduleDefinitionToFlexTemplateNode = (
  moduleDefinition: ModuleDefinition,
  includeDescendants: boolean = true
): ExtendedFTNode => {
  const flexComponentName = getNameFromModuleDefinition(moduleDefinition);
  const flexComponentView = moduleDefinition.view ? moduleDefinition.view : undefined;

  let view = flexComponentName;

  if (flexComponentView && flexComponentView !== "default") {
    view = `${view}_${flexComponentView}`;
  }

  //TODO: remove complexity here when we start getting id's consistently from the template for all components
  const id = moduleDefinition.id;

  const options = {
    ...moduleDefinition,
    flexComponentName,
    flexComponentView,
  } as any;

  delete options.id;
  delete options.name;
  delete options.modules;
  delete options.children;
  delete options.groups;
  delete options.view;

  if (
    getNameFromModuleDefinition(moduleDefinition) === "tab" ||
    getNameFromModuleDefinition(moduleDefinition) === "region"
  ) {
    options.containerName = moduleDefinition.name;
  }

  const flexTemplateNode: ExtendedFTNode = {
    id,
    view,
    options,
  };

  if ((moduleDefinition.modules || moduleDefinition.groups || moduleDefinition.children) && includeDescendants) {
    //TODO: all children are assumed as array type since this matches Template and Composition structure. How to use map type children via Template or Composition?

    // gather and create decendant BlossomComponents
    const childModuleDefinitions: ModuleDefinition[] = [
      ...(moduleDefinition.modules || []),
      ...(moduleDefinition.groups || []),
      ...(moduleDefinition.children || []),
    ];

    const childNodes = childModuleDefinitions
      .map((child) => moduleDefinitionToFlexTemplateNode(child))
      .filter((node) => !!node);

    if (childNodes.length > 0) {
      flexTemplateNode.childNodes = childNodes;
    }
  }

  return flexTemplateNode;
};
